import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { observer, inject } from 'mobx-react'

import leftLogoStyles from './styles/LeftLogoStyle'
import { IProps as ILoadingProps } from '../Login/index'
export interface IProps
  extends ILoadingProps,
    WithStyles<typeof leftLogoStyles> {}

@inject('AppStore')
@observer
class LeftLogo extends React.Component<
  Pick<IProps, 'AppStore' | 'classes' | 'coverImg'>,
  any
> {
  public render() {
    const { classes, AppStore, coverImg } = this.props
    return (
      <div
        className={classes.left}
        style={{
          backgroundImage: `url(${coverImg || AppStore.theme.coverImg})`,
        }}
      >
        {AppStore.individualInfo.logoUrl && (
          <div className={classes.urlContainer}>
            <img
              className={classes.loginUrl}
              src={AppStore.individualInfo.logoUrl}
            />
          </div>
        )}
        {/* {(!AppStore.isCustomLogin && <div className={classes.logo} />) || null} */}
      </div>
    )
  }
}
export default withStyles(leftLogoStyles)(LeftLogo)
